import React from 'react'
import { Select as MuiSelect } from '@mui/material'

export default function Select(): ReactNode {
    return <MuiSelect color="secondary" multiple size="small" fullWidth />
}
